import type { MessageOriginName } from "@multi-chat/shared";
import { cn } from "../../lib/utils.js";

/** Restrained origin/source chips for Outgoing + Message Log. */
export function reportOriginChipClass(origin: MessageOriginName | null | undefined): string {
  switch (origin) {
    case "CAMPAIGN":
      return "border-accent/25 bg-accent/10 text-accent";
    case "CAMPAIGN_SEND_TEST":
      return "border-warning/30 bg-warning-muted text-warning";
    case "INBOX":
      return "border-success/25 bg-success-muted text-success";
    case "SYSTEM":
      return "border-line/70 bg-surface-muted text-ink-muted";
    case "AI_AGENT":
    case "AUTOMATION":
    case "API":
    case "MOBILE_APP":
    case undefined:
    case null:
      return "border-line/60 bg-surface text-foreground";
    default: {
      const _exhaustive: never = origin;
      return _exhaustive;
    }
  }
}

export function ReportOriginChip({
  origin,
  label,
}: {
  origin: MessageOriginName | null | undefined;
  label: string;
}): React.JSX.Element {
  return (
    <span
      className={cn(
        "inline-flex max-w-full items-center truncate rounded-full border px-2 py-0.5 text-[0.6875rem] font-medium",
        reportOriginChipClass(origin),
      )}
    >
      {label}
    </span>
  );
}
